// extracted by mini-css-extract-plugin
module.exports = {"thumb":"Slider__thumb___2J4tg","trackBefore":"Slider__trackBefore___3gWSa","trackAfter":"Slider__trackAfter___3SUNg","track":"Slider__track___2fka3"};